import React from 'react';
import ReactQuill from 'react-quill';
import { convertHtmlToDelta } from 'utils/quillUtils';
import { Box, Tooltip, Typography } from '@mui/material';

interface Props {
  guidelines: string;
}

export const Description = ({ guidelines }: Props) => (
  <Box className="description">
    <Typography component="span" variant="subtitle2">
      Finance Program Description
    </Typography>

    <Tooltip arrow title="Customize the Finance Program Description as it appears on proposals (Optional).">
      <Box className="content">
        <ReactQuill theme="bubble" readOnly value={convertHtmlToDelta(guidelines)} />
      </Box>
    </Tooltip>
  </Box>
);
